import { z } from "zod";
import { idSchema } from "@amber/contracts";

export const msTupleSchema = z
  .tuple([z.number().int().nonnegative(), z.number().int().positive()])
  .refine(([start, end]) => start < end, "range start must be before its end");
export type MsTuple = z.infer<typeof msTupleSchema>;

export const languageTagSchema = z.string().regex(/^[a-z]{2,3}(-[A-Za-z0-9]{2,8})*$/, "expected a BCP 47 language tag");

export const scoreSchema = z.number().min(0).max(1);

export const EVIDENCE_REF_KINDS = ["profile", "item", "source_version", "artifact", "url"] as const;

export const evidenceRefSchema = z.discriminatedUnion("kind", [
  z.strictObject({ kind: z.literal("profile"), profile_id: idSchema("prf") }),
  z.strictObject({ kind: z.literal("item"), item_id: idSchema("itm") }),
  z.strictObject({ kind: z.literal("source_version"), source_version_id: idSchema("ver") }),
  z.strictObject({ kind: z.literal("artifact"), artifact_id: idSchema("art") }),
  z.strictObject({ kind: z.literal("url"), url: z.url() }),
]);
export type EvidenceRef = z.infer<typeof evidenceRefSchema>;

export const WITHDRAWAL_CAUSES = ["restricted", "deleted", "invalidated"] as const;
export const withdrawalCauseSchema = z.enum(WITHDRAWAL_CAUSES);

export function inFixedOrder<T extends z.ZodType>(order: readonly string[], schema: T) {
  return z.preprocess((value, ctx) => {
    if (value !== null && typeof value === "object" && Object.keys(value).join(",") !== order.join(",")) {
      ctx.addIssue({ code: "custom", message: `keys must appear in the order ${order.join(", ")}` });
    }
    return value;
  }, schema);
}
